(function ($) {
    if (!$ || !$.fn) {
        return;
    }

    var settings = {};
    var JPEG_MIME = 'image/jpeg';
    // Keep in sync with Kronos IMAGE_JPEG_QUALITY (and Kore Image::JPEG_QUALITY).
    var JPEG_QUALITY = 0.90;

    $.fn.fileinput_to_dataurl = function(options) {
        if (!$ || !$.fn) {
            return this;
        }
        if (!this.length) {
            return this;
        }

        settings = $.extend({
            max_width: 100,
            jpeg_quality: JPEG_QUALITY,
            data_url_input: null,
            callback: null
        }, options);

        var $file_input = this;
        var $form = $file_input.closest('form');

        if ($('#'+settings.data_url_input).length === 0) {
            $file_input.before('<input type="hidden" name="'+settings.data_url_input+'" id="'+settings.data_url_input+'" />');
        }

        $form.on('submit', function(e) {
            e.preventDefault();
            $file_input.val('');
            this.submit();
        });

        process($file_input);
    };

    function process($file_input) {
        if (window.File && window.FileReader && window.FormData) {
            $file_input.on('change', function(e) {
                var file = e.target.files[0];

                if (file && /^image\//i.test(file.type)) {
                    read_photo(file);
                }
            });
        }
    };

    function read_photo(photo)
    {
        var reader = new FileReader();

        reader.onloadend = function () {
            process_photo(reader.result, photo);
        }

        reader.readAsDataURL(photo);
    };

    function encode_jpeg(image, new_width, new_height, orientation)
    {
        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        var quality = settings.jpeg_quality;

        if (orientation && [6, 8].indexOf(orientation) > -1) {
            canvas.width = new_height;
            canvas.height = new_width;
        } else {
            canvas.width = new_width;
            canvas.height = new_height;
        }

        context.fillStyle = '#FFFFFF';
        context.fillRect(0, 0, canvas.width, canvas.height);

        if (orientation && orientation == 6) {
            context.transform(0, 1, -1, 0, new_height, 0);
        } else if (orientation && orientation == 8) {
            context.transform(0, -1, 1, 0, 0, new_width);
        } else if (orientation && orientation == 3) {
            context.transform(-1, 0, 0, -1, new_width, new_height);
        }

        context.drawImage(image, 0, 0, new_width, new_height);
        var data_url = canvas.toDataURL(JPEG_MIME, quality);

        $('#'+settings.data_url_input).val(data_url);

        if (typeof settings.callback === 'function') {
            (settings.callback)();
        }
    }

    function process_photo(data_url, photo)
    {
        var max_width = parseInt(settings.max_width, 10) || 100;
        var image = new Image();

        image.src = data_url;

        image.onload = function () {
            var width = image.width;
            var height = image.height;
            var scale = width > max_width ? (max_width / width) : 1;
            var new_width = width * scale;
            var new_height = height * scale;

            // Always re-encode as JPEG: photos stay under Engine's 100 KiB
            // portrait cap, PNG/alpha sources become opaque JPEG; EXIF
            // orientation is applied when exif-js is available.
            if (typeof EXIF === 'function') {
                EXIF.getData(photo, function() {
                    encode_jpeg(image, new_width, new_height, EXIF.getTag(this, 'Orientation'));
                });
            } else {
                encode_jpeg(image, new_width, new_height, null);
            }
        }
    }
}(window.jQuery));
